import { IClassroom } from "../../classrooms";
import { IGroupSpaceResource } from "../../group-spaces";
import { ISkillResource } from "../../skills";
import { IUserResource } from "../../users";
import { createApiQueryHook, IApiQueryFunction, IOrderable, IPaginateable, mapPagination } from "../../utils/api";
import { mapRelationalFilter, RelationalFilter } from "../../utils/filters";
import { serialize } from "../../utils/url";
import { CreatedAtParam, IGroupCorrectionList } from "../types";

export interface IGroupCorrectionListQueryParameters extends IPaginateable, IOrderable<"createdAt"> {
    filters?: {
        groupSpace?: RelationalFilter<IGroupSpaceResource>;
        learner?: RelationalFilter<IUserResource>;
        groupSpaceClassroom?: RelationalFilter<IClassroom>;
        groupSpaceSkill?: RelationalFilter<ISkillResource>;
        intervalStart?: string;
        intervalEnd?: string;
        createdAt?: {
            date?: string;
            param?: CreatedAtParam;
        };
    };
}

export type IGroupCorrectionListQueryResult = IGroupCorrectionList;

const mapFilters = (filters: IGroupCorrectionListQueryParameters["filters"]) => {
    const { groupSpace, learner, groupSpaceClassroom, groupSpaceSkill, intervalStart, intervalEnd, createdAt } =
        filters ?? {};

    return {
        "groupSpace.uuid": mapRelationalFilter(groupSpace),
        "learner.uuid": mapRelationalFilter(learner),
        "groupSpace.classroom.uuid": mapRelationalFilter(groupSpaceClassroom),
        "groupCorrectedSkillLevels.skillLevel.skill.uuid": mapRelationalFilter(groupSpaceSkill),
        "interval[start]": intervalStart,
        "interval[end]": intervalEnd,
        [`createdAt[${createdAt?.param ?? CreatedAtParam.BEFORE}]`]: createdAt?.date,
    };
};

export const groupCorrectionListQuery: IApiQueryFunction<IGroupCorrectionListQueryParameters> = ({
    filters,
    pagination,
}) => {
    return {
        method: "GET",
        url: `/group_corrections${serialize(
            {
                ...mapPagination(pagination),
                ...mapFilters(filters),
            },
            true,
        )}`,
    };
};

export const useGroupCorrectionListQuery = createApiQueryHook<
    IGroupCorrectionListQueryParameters,
    IGroupCorrectionListQueryResult
>(groupCorrectionListQuery);
